import { HTMLAttributes } from 'react';
import { FlexboxProps, LayoutProps, SpaceProps } from 'styled-system';

export enum ContainerVariants {
  INFO = 'info',
  DEFAULT = 'default',
}
interface IFlexContainer
  extends FlexboxProps,
    LayoutProps,
    SpaceProps,
    HTMLAttributes<{}> {
  variant?: ContainerVariants;
}

export default IFlexContainer;
